var React = require('react');

function Favicon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2944_45474)","key":0},React.createElement("path",{"d":"M17.0696 -4.54688L17.6117 14.3543L27.5311 -1.74318L18.5494 14.8964L35.1889 5.91466L19.0915 15.8341L37.9926 16.3762L19.0915 16.9183L35.1889 26.8377L18.5494 17.856L27.5311 34.4956L17.6117 18.3981L17.0696 37.2993L16.5275 18.3981L6.60802 34.4956L15.5897 17.856L-1.04982 26.8377L15.0476 16.9183L-3.85352 16.3762L15.0476 15.8341L-1.04982 5.91466L15.5897 14.8964L6.60802 -1.74318L16.5275 14.3543L17.0696 -4.54688Z","fill":"#F7C800"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2944_45474"},React.createElement("rect",{"width":"41.8462","height":"41.8462","fill":"white","transform":"translate(-3.85352 -4.54688)"})))]);
}

Favicon.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = Favicon;

Favicon.default = Favicon;
